import React from 'react'

const HeaderBar = () => {
    return (
        <div className='head'>
             <div className="container">
                <div className="header_banner"></div>
             </div>
        </div>

    )
}

export default HeaderBar;